import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import Faq from "../../components/Contato/Faq";
import InfoContato from "../../components/Contato/InfoContato";
import Sac from "../../components/Contato/Sac";
import FormContato from "../../components/FormContato";
import TitleDefault from "../../components/TitleDefault";
import { IGeneralSettings } from "../../interfaces/GeneralSettings";
import fetchAPI from "../../lib/api";

interface FaqProps {
  faq: any;
}

export default function Contato({
  generalSettings,
  faq,
}: IGeneralSettings & FaqProps) {
  return (
    <Flex
      w="full"
      flexDir="column"
      pt="60px"
      className="template-page page-slug-contato"
    >
      <Flex
        w={["80%", "80%", "90%", "90%", "1170px"]}
        flexDir="column"
        mx="auto"
      >
        <InfoContato
          telefones={generalSettings.telefones}
          emails={generalSettings.emails}
          endereco={generalSettings.endereco}
        />
        <Sac />
        <Faq initialData={faq} />
        <TitleDefault subtitulo="FORMULÁRIO" titulo="Fale conosco" />
        <Text>
          Para sugestões, críticas, elogios e/ou outros, preencha o formulário
          abaixo.
        </Text>
        <FormContato />
      </Flex>
    </Flex>
  );
}

export async function getStaticProps() {
  const generalSettings = await fetchAPI("/configuracoes-gerais");
  const faq = await fetchAPI("/faqs?_sort=id:DESC");

  return {
    props: { generalSettings, faq },
    revalidate: 30,
  };
}
